import { useDebounce } from '@shared/utils/hooks/useDebounce';
import { addAction } from '@shared/utils/logger';
import { useEffect } from 'react';

export function useSearchTermTelemetry(term: string) {
  // Debounce 3s to filter out the noise during typing.
  const debouncedTerm = useDebounce(term, 3000);

  useEffect(() => {
    if (!debouncedTerm) return;
    addAction('TermSearched', {
      term: debouncedTerm,
    });
  }, [debouncedTerm]);
}
